module.exports = __webpack_public_path__ + "static/media/diploma.abd9a451.svg";